import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const B = () => {
    const { t } = useLang('recall.C');

    return (
        <div className={`${css.page}`}>
            <img className="success-icon" src="https://websiteoss.ecoflow.com/upload/image/1739425965453/done.png" alt="" />
            <div className="success-text">{t('desc')}</div>
        </div>
    );
};
export default B;
